import Animation from './components/animation'
// import Cookies from './components/cookies'
import BackToTop from './components/back-to-top'
import MobileMenu from './components/mobile-menu'
import Navbar from './components/navbar'
import OrphanChars from './components/orphan-chars'
import ScrollToAnchor from './components/scroll-to-anchor'
import Slider from './components/slider'
import List from './components/list'

window.addEventListener('DOMContentLoaded', () => {
    new Animation()
//    new Cookies()
    new BackToTop()
    new MobileMenu()
    new Navbar()
    new OrphanChars()
    new ScrollToAnchor()
    new Slider()

    let lists = document.querySelectorAll('[data-list]');
    if( lists.length ) {
        lists.forEach(function(list) {
            new List(list)
        })
    }
})



//////////////////
// WEBPACK FOOTER
// ./js/main.js
// module id = 5
// module chunks = 0